import {
	BusinessInfoContainer,
	SecurityContainer,
	InviteFriendsContainer,
	LogoutContainer,
	ContactSupportContainer,
	WithdrawalAccountContainer,
	KycContainer,
	FaqsContainer,
	GeneralSettingsContainer,
} from '../../containers';
import {
	MdSecurity,
} from 'react-icons/md';
import styles from '../../assets/styles/Settings/Settings.module.scss';
import {
	BsPersonFill,
	BsPersonBadgeFill,
} from 'react-icons/bs';
import { MimaText, AppPage, PageLoader } from '../../components';
import { businessStore, userStore } from '../../stores';
import { RiLogoutCircleFill } from 'react-icons/ri';
import { IoIosArrowForward, IoIosCash } from 'react-icons/io';
import { BiSupport } from 'react-icons/bi';
import { AnimatePresence } from 'framer-motion';
import { FaUserFriends, FaQuestionCircle } from 'react-icons/fa';
import { IoBusiness, IoSettings } from 'react-icons/io5';
import React, { useState } from 'react';
import { GrDocumentConfig } from 'react-icons/gr';
import { TbKeyframeAlignCenterFilled } from 'react-icons/tb';

const Settings = ({
	generalSettingsModal,
	goToGeneralSettings,
	goToFaq,
	faqModal,
	businessInfo,
	goToBusinessInfo,
	securityModal,
	withdrawalAccountModal,
	inviteFriendsModal,
	supportModal,
	logoutModal,
	loading,
	goToSecurity,
	goToWithdrawalAccount,
	goToInvite,
	goToSupport,
	goTologout,
	closeModal,
	goToKyc,
	kycModal,
	tier,
	refresh,
	goToApiKeys,
}) => {
	const navData = [

		{
			title: 'Business Information',
			module: 'BUSINESS DETAILS',
			icon: <BsPersonFill />,
			link: goToBusinessInfo,
		},
		{
			title: 'Pin and Security',
			icon: <MdSecurity />,
			link: goToSecurity,
		},
		{
			title: 'Business Account Settings',
			module: 'BUSINESS DETAILS',
			icon: <IoBusiness />,
			// link: goToBusinessInfo,
			subNavData: [
				{
					title: 'KYC Verification',
					type: 'GENERAL',
					icon: <BsPersonBadgeFill />,
					link: goToKyc,
				},
				{
					title: 'Set Withdrawal Account',
					module: 'BUSINESS BANK ACCOUNT',
					type: 'GENERAL',
					icon: <IoIosCash />,
					link: goToWithdrawalAccount,
				},
			],
		},
		{
			title: 'Configurations',
			module: 'BUSINESS DETAILS',
			icon: <GrDocumentConfig />,
			// link: goToBusinessInfo,
			subNavData: [

				// {
				// 	title: "Products Sales Configuration",
				// 	icon: <MdOutlineProductionQuantityLimits />,
				// 	link: goToProductSalesConfig,
				// },
				{
					title: 'General Settings',
					icon: <IoSettings />,
					link: goToGeneralSettings,
				},
			],
		},
		{
			title: 'Support',
			icon: <BiSupport />,
			link: goToSupport,
		},
		
		{
			title: 'Invite Friends',
			icon: <FaUserFriends />,
			link: goToInvite,
		},
		{
			title: 'FAQs',
			module: 'BUSINESS DETAILS',
			icon: <FaQuestionCircle />,
			link: goToFaq,
		},
		{
			title: 'Logout',
			icon: <RiLogoutCircleFill />,
			link: goTologout,
		},
	];

	const { user } = userStore;
	const name = businessStore.business?.tradingName;

	const userPermissions = user?.permissions || [];

	const [expandedNav, setExpandedNav] = useState(-1);

	return (
		<AppPage pageTitle="Settings" refresh={refresh}>
			{loading ? (
				<PageLoader title="While we set things up for you" loading={loading} />
			) : (
				<>
					<div>
						<div className={styles.upper}>
							<div className={styles.upper__title}>
								<div className={styles.upper__title_shape}>
									{' '}
									{Array?.from(name)[0]?.toUpperCase()}
								</div>
								<MimaText variant="subtitleBold"> {name}</MimaText>
							</div>
						</div>
						<>
							<div className={styles.main__nav}>
								{navData.map((navItem, index) => (
									<React.Fragment key={index}>
										{!navItem.module ||
											new Set(userPermissions.map(perm => perm.module)).has(
												navItem.module
											) ||
											(navItem.type === 'GENERAL' &&
												user.accountType === 'Employee') ? (
											<>
												<div
													className={styles.main__nav_item}
													onClick={() => {
														if (navItem.subNavData) {
															if (expandedNav === index) {
																setExpandedNav(-1);
															} else {
																setExpandedNav(index);
															}
														} else {
															navItem.link();
														}
													}}
													key={index}>
													<div className={styles.main__nav_item__icon}>
														{navItem.icon}
													</div>
													{navItem.title}

													<IoIosArrowForward
														className={
															navItem.subNavData && expandedNav === index
																? styles.main__nav_item__icon2
																: styles.main__nav_item__icon
														}
													/>
												</div>

												{navItem.subNavData && expandedNav === index && (
													<>
														{navItem.subNavData.map((x, i) => (
															<div
																className={styles.sub__nav_item}
																onClick={() => {
																	setExpandedNav(-1);
																	x.link();
																}}
																key={i}>
																<div className={styles.sub__nav_item__icon}>
																	{x.icon}
																</div>
																{x.title}
																<div className={styles.sub__nav_item__icon}>
																	<IoIosArrowForward />
																</div>
															</div>
														))}
													</>
												)}
											</>
										) : (
											''
										)}
									</React.Fragment>
								))}
							</div>
						</>
					</div>
					{(businessInfo ||
						securityModal ||
						withdrawalAccountModal ||
						inviteFriendsModal ||
						supportModal ||

						logoutModal ||
						kycModal ||

						faqModal ||
						generalSettingsModal
					) && (
							<div className="modal">
								<AnimatePresence>
									{businessInfo && (
										<BusinessInfoContainer closeModal={closeModal} />
									)}

									{securityModal && <SecurityContainer closeModal={closeModal} />}

									{withdrawalAccountModal && (
										<WithdrawalAccountContainer closeModal={closeModal} />
									)}
									{inviteFriendsModal && (
										<InviteFriendsContainer closeModal={closeModal} />
									)}
									{supportModal && (
										<ContactSupportContainer closeModal={closeModal} />
									)}
									{logoutModal && <LogoutContainer closeModal={closeModal} />}
									{kycModal && (
										<KycContainer closeModal={closeModal} tier={tier} />
									)}
									{faqModal && <FaqsContainer closeModal={closeModal} />}
									{generalSettingsModal && (
										<GeneralSettingsContainer closeModal={closeModal} />
									)}

								</AnimatePresence>
							</div>
						)}
				</>
			)}
		</AppPage>
	);
};

export default Settings;
